import type { Partner } from "@apps/gwservice/types"
import { Card } from "~/components/ui/card"
import { RemoteImg } from "~/components/ui/remote-img"

interface Props {
  partner: Partner
}

function CardContent({ partner }: Props) {
  return (
    <Card className="flex flex-row items-center p-0! w-full">
      {partner.cover && (
        <div className="relative py-m pl-m w-group-img self-stretch min-h-group-img shrink-0">
          <RemoteImg src={partner.cover.url} alt={partner.title} className="object-cover size-full" />
        </div>
      )}
      <div className="flex-1 px-m py-s flex flex-col gap-1 min-w-0">
        <div className="text-base line-clamp-2" lang="ru">{partner.title}</div>
        {partner.info && (
          <div className="text-sm text-muted-foreground line-clamp-2 hyphens-auto" lang="ru">{partner.info}</div>
        )}
      </div>
    </Card>
  )
}

export function PartnerCard({ partner }: Props) {
  if (partner.link) {
    return (
      <a href={partner.link} target="_blank" rel="noopener noreferrer">
        <CardContent partner={partner} />
      </a>
    )
  }

  return <CardContent partner={partner} />
}
